import React from 'react';

import { VFText, Card, Toggle } from '@vfgroup-oneplatform/foundation/Components';
import PropTypes from 'prop-types';

import style from './PaymentOptionsSectionStyle';

const PaymentOptionsSection = ({ theme, title, dayOfMonthlyBill }) => (
  <Card style={style.card(theme)} cardAccessible={false}>
    <VFText style={style.mainTitle} i18nKey={title} placeHolders={[dayOfMonthlyBill]} />
    <Toggle selected initialValue={true} />
  </Card>
);

PaymentOptionsSection.defaultProps = {
  title: 'Add to monthly bill (25th)',
};

PaymentOptionsSection.propTypes = {
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  title: PropTypes.string,
  dayOfMonthlyBill: PropTypes.string,
};

export default PaymentOptionsSection;
